import { render, staticRenderFns } from "./RoleDetailsPopup.vue?vue&type=template&id=99cd94dc&scoped=true&"
import script from "./RoleDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./RoleDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetailsPopup.vue?vue&type=style&index=0&id=99cd94dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cd94dc",
  null
  
)

export default component.exports